import React, {CSSProperties, useCallback, useRef} from "react";
import {useCreation, useSize} from "ahooks";
import {BroadcastUtils, EnvironmentUtils, Media} from "filkersjs-model/dist";

export interface MediaCardProps {
    media: Media,
    selected?: boolean,
    style?: CSSProperties,
    onClick?: () => any
}

const MediaCard = ({media, style, onClick, selected = false}: MediaCardProps) => {

    const mediaContainerRef = useRef<HTMLDivElement>();
    const mediaContainerSize = useSize(mediaContainerRef);

    const mediaUrl = useCreation(() => {
        if (media === undefined) {
            return undefined;
        }

        // Si pasa algo raro con el tamaño, cogemos por defecto 480x480, que ha de llegar
        const containerSize = mediaContainerSize === undefined || mediaContainerSize.width === undefined || mediaContainerSize.width < 10
            ? {width: 480, height: 480}
            : mediaContainerSize;

        // Calculamos el tamaño de imagen que necesitamos para llenar este espacio, teniendo en cuenta las relaciones de aspecto
        const containerAR = containerSize.width / containerSize.height;
        const mediaAR = media.width / media.height;

        let requiredImageSize = {width: 1, height: 1};
        if (containerAR >= mediaAR) {
            // Si el contenedor es mas ancho que la imagen, el ancho de la imagen debe coincidir con el del contenedor
            // y habra que ampliar el alto a lo que haga falta
            requiredImageSize.width = containerSize.width;
            requiredImageSize.height = Math.floor(requiredImageSize.width / mediaAR);
        } else {
            // En el caso contrario, coincide el alto y escalamos el ancho
            requiredImageSize.height = containerSize.height;
            requiredImageSize.width = Math.floor(requiredImageSize.height * mediaAR);

        }


        const mediaSearchResult = BroadcastUtils.getMediaVersionSelectionStrategy().findMediaVersion(media, requiredImageSize.width, requiredImageSize.height);
        return EnvironmentUtils.getMediaBaseUrl(mediaSearchResult.media).concat(mediaSearchResult.version.path);
    }, [media, mediaContainerSize]);

    const clickHandler = useCallback((event) => {
        if (onClick !== undefined) {
            onClick();
        }
    }, [onClick])

    return (
        <div
            ref={mediaContainerRef}
            onClick={clickHandler}
            style={style}>
            <div

                className={`flk-media-card ${selected === true ? 'flk-selected' : ''} ${onClick !== undefined ? 'flk-clickable-item' : ''}`}
                style={{
                    backgroundImage: mediaUrl === undefined ? undefined : `url(${mediaUrl})`,
                }}/>
        </div>
    );

}

export default MediaCard;